/**
 * Turns a stored base64 image into a data URL. Older photos are stored as PNG, newer ones as JPEG,
 * so the mimetype is read from the first bytes instead of being assumed. Defaults to PNG.
 */
export function base64ImageToDataUrl(base64: string) {
    if (base64?.startsWith('/9j/')) {
        return `data:image/jpeg;base64,${base64}`
    }

    return `data:image/png;base64,${base64}`
}
